import { listDesignerWorkflowSteps } from "../../designer-workflow-step-actions";
import { getSdInstance } from "../helpers";
import type { IStandingSnapshot } from "./workflow-dsl-halt-standing";

/**
 * KOA-18593 — the process as `LIST` shows it, for the halt gate: the same listing the author reads,
 * so the gate and the author judge "what is still missing" from one picture. Undefined when the
 * process cannot be read — the gate then compares text alone, exactly as it did before.
 */
export function readStandingSnapshot(): IStandingSnapshot | undefined {
  try {
    const listed: ReturnType<typeof listDesignerWorkflowSteps> = listDesignerWorkflowSteps(getSdInstance());
    if ("error" in listed) return undefined;
    return { steps: listed.steps, parameters: listed.parameters };
  } catch {
    return undefined;
  }
}
